import {useMemo, useState} from 'react';
import {AutocompleteInput, Option} from '../role-autocomplete/autocomplete-input';

type AttendanceFilterSelectProps = {
  /** Options to choose from, besides the one that clears the filter */
  options: {key: string; label: string}[];
  /** Label of the option that clears the filter (already translated), e.g. "All states" */
  label: string;
  /** Key of the option chosen, or `undefined` when the filter was cleared */
  onChange: (key: string | undefined) => void;
};

/** Select of a filter of the attendance tracker, to be used in the header of the screens of the office */
export default function AttendanceFilterSelect({
  options,
  label,
  onChange,
}: AttendanceFilterSelectProps) {
  const autocompleteOptions = useMemo<Option[]>(
    () => options.map(({key, label: optionLabel}) => ({key, label: optionLabel, picture: ''})),
    [options]
  );
  const [selectedOption, setSelectedOption] = useState<Option>({key: '', label, picture: ''});

  return (
    <AutocompleteInput
      sx={{width: 150}}
      options={autocompleteOptions}
      selectedOption={selectedOption}
      showEmptyOption
      hideAvatars
      emptyOptionLabel={label}
      onChange={(option) => {
        setSelectedOption(option);
        onChange(option.key || undefined);
      }}
    />
  );
}
